// Icon.tsx
// Icons import
import Add from '~/icons/add.svg';
import AlertTriangle from '~/icons/alert-triangle.svg';
import Alert from '~/icons/alert.svg';
import AndercoreA from '~/icons/andercore-a.svg';
import AndercoreLogoBig from '~/icons/andercore-logo-big.svg';
import AndercoreLogoSmall from '~/icons/andercore-logo-small.svg';
import Archived from '~/icons/archived.svg';
import ArrowLeft from '~/icons/arrow-left.svg';
import ArrowRight from '~/icons/arrow-right.svg';
import Bell from '~/icons/bell.svg';
import BillingAddress from '~/icons/billing-address.svg';
import Billing from '~/icons/billing.svg';
import BusinessHandshake from '~/icons/business-handshake.svg';
import HandPointingRight from '~/icons/hand-pointing-right.svg';
import Calendar from '~/icons/calendar.svg';
import Calculator from '~/icons/calculator.svg';
import CalendarWeek from '~/icons/calendar-week.svg';
import InfoCircle from '~/icons/info-circle.svg';
import CancelCircle from '~/icons/cancel-circle.svg';
import Cancel from '~/icons/cancel.svg';
import CategoryInverter from '~/icons/category-inverter.svg';
import ChatBubble from '~/icons/chat-bubble-oval-smiley.svg';
import ChatQuestionMark from '~/icons/chat-question-mark.svg';
import CheckCircle from '~/icons/check-circle.svg';
import Copy from '~/icons/copy.svg';
import SuccessfulChecked from '~/icons/successful-checked.svg';
import Check from '~/icons/check.svg';
import CheckboxChecked from '~/icons/checkbox-checked.svg';
import {
  default as CheckboxUnchecked,
  default as CheckboxUnChecked,
} from '~/icons/checkbox-unchecked.svg';
import ChevronDown from '~/icons/chevron-down.svg';
import ChevronLeft from '~/icons/chevron-left.svg';
import ChevronUp from '~/icons/chevron-up.svg';
import ClaimBilling from '~/icons/claimManagement/billing.svg';
import ClaimManagement from '~/icons/claimManagement/claimManagement.svg';
import ClaimDelivery from '~/icons/claimManagement/delivery.svg';
import Dimensions from '~/icons/dimensions.svg';
import DisabledTag from '~/icons/disabled-tag.svg';
import LastUpdated from '~/icons/claimManagement/lastUpdated.svg';
import MessageRead from '~/icons/claimManagement/messageRead.svg';
import NoComments from '~/icons/claimManagement/noComments.svg';
import Comment from '~/icons/comment.svg';
import Pieces from '~/icons/pieces.svg';
import BillingInformation from '~/icons/claimManagement/reasons/billing-information.svg';
import LateDelivery from '~/icons/claimManagement/reasons/late-delivery.svg';
import MaterialDefect from '~/icons/claimManagement/reasons/material-defect.svg';
import OtherReason from '~/icons/claimManagement/reasons/other.svg';
import PackagingDamage from '~/icons/claimManagement/reasons/packaging-damage.svg';
import PaidAlready from '~/icons/claimManagement/reasons/paid-already.svg';
import PaymentAmount from '~/icons/claimManagement/reasons/payment-amount.svg';
import Performance from '~/icons/claimManagement/reasons/performance.svg';
import ProductQuantity from '~/icons/claimManagement/reasons/product-quantity.svg';
import ProductionDate from '~/icons/claimManagement/reasons/production-date.svg';
import SerialNumber from '~/icons/claimManagement/reasons/serial-number.svg';
import ReasonSoftware from '~/icons/claimManagement/reasons/software.svg';
import WrongProducts from '~/icons/claimManagement/reasons/wrong-products.svg';
import Pallets from '~/icons/pallets.svg';
import Resolved from '~/icons/claimManagement/resolved.svg';
import ClipboardCheck from '~/icons/clipboard-Check.svg';
import Clock from '~/icons/clock.svg';
import CoffeeMug from '~/icons/coffee-mug.svg';
import Coins from '~/icons/coins.svg';
import CoreLogo from '~/icons/core-logo.svg';
import Collapse from '~/icons/collapse.svg';
import CompanyBuilding from '~/icons/company-building.svg';
import ContactDetails from '~/icons/contact-details.svg';
import Cookies from '~/icons/cookies.svg';
import CookiesPreferences from '~/icons/cookies-preferences.svg';
import AT from '~/icons/country/at.svg';
import BE from '~/icons/country/be.svg';
import CZ from '~/icons/country/cz.svg';
import DE from '~/icons/country/de.svg';
import EN from '~/icons/country/en.svg';
import ES from '~/icons/country/es.svg';
import FR from '~/icons/country/fr.svg';
import IT from '~/icons/country/it.svg';
import NL from '~/icons/country/nl.svg';
import PL from '~/icons/country/pl.svg';
import PT from '~/icons/country/pt.svg';
import CH from '~/icons/country/sw.svg';
import DeliveryCancelled from '~/icons/delivery-cancelled.svg';
import DeliveryCompleted from '~/icons/delivery-completed.svg';
import DeliveryContact from '~/icons/delivery-contact.svg';
import DeliveryInProgress from '~/icons/delivery-in-progress.svg';
import DeliveryScheduled from '~/icons/delivery-scheduled.svg';
import DeliveryTruck from '~/icons/delivery-truck.svg';
import Delivery from '~/icons/delivery.svg';
import DesktopWithPerson from '~/icons/desktop-with-person.svg';
import DisputeBubble from '~/icons/dispute-bubble.svg';
import DocumentLines from '~/icons/document-lines.svg';
import Discount from '~/icons/discount.svg';
import Document from '~/icons/document.svg';
import Documents from '~/icons/documents.svg';
import Download from '~/icons/download.svg';
import Pencil from '~/icons/edit-pencil.svg';
import EmptyList from '~/icons/empty-list.svg';
import EmptyBilling from '~/icons/empty-state/billing.svg';
import NoClaims from '~/icons/empty-state/claim.svg';
import EmptyNotFound from '~/icons/empty-state/notfound.svg';
import EmptyOrders from '~/icons/empty-state/orders.svg';
import EmptyQuotes from '~/icons/empty-state/quotes.svg';
import Envelope from '~/icons/envelope.svg';
import Expand from '~/icons/expand.svg';
import EyeClosed from '~/icons/eye-closed.svg';
import EyeOpen from '~/icons/eye-open.svg';
import FallbackImage from '~/icons/fallback-image.svg';
import FileAttachement from '~/icons/file-attachement.svg';
import Flag from '~/icons/flag.svg';
import HomeBig from '~/icons/home-big.svg';
import Home from '~/icons/home.svg';
import HourGlass from '~/icons/hourglass.svg';
import IllustrativeSearch from '~/icons/illustrative-search.svg';
import InvoiceDue from '~/icons/invoice-due.svg';
import Loader from '~/icons/loader.svg';
import Location from '~/icons/location.svg';
import Lock from '~/icons/lock.svg';
import Logout from '~/icons/logout.svg';
import Mail from '~/icons/mail.svg';
import Minus from '~/icons/minus.svg';
import OfferOpen from '~/icons/offer-open.svg';
import OfferRejected from '~/icons/offer-rejected.svg';
import Offers from '~/icons/offers.svg';
import OfficeBuilding from '~/icons/office-building.svg';
import OnHoldOrPause from '~/icons/on-hold-or-pause.svg';
import OrderCancelled from '~/icons/order-cancelled.svg';
import OrderCompleted from '~/icons/order-completed.svg';
import OrderConfirmed from '~/icons/order-confirmed.svg';
import OrderPlaced from '~/icons/order-placed.svg';
import Orders from '~/icons/orders.svg';
import PackageCancelled from '~/icons/package-cancelled.svg';
import PackageDelivered from '~/icons/package-delivered.svg';
import PadLock from '~/icons/padlock.svg';
import Percent from '~/icons/percent.svg';
import Preferences from '~/icons/preferences.svg';
import Printer from '~/icons/printer.svg';
import Profile from '~/icons/profile.svg';
import QuoteNew from '~/icons/quote-new.svg';
import Quotes from '~/icons/quotes.svg';
import Settings from '~/icons/settings.svg';
import ShippingBox from '~/icons/shipping-box.svg';
import Shop from '~/icons/shop.svg';
import Smartphone from '~/icons/smartphone.svg';
import AcPowerRange from '~/icons/store/acPowerRange.svg';
import Batteries from '~/icons/store/batteries.svg';
import BatteryVoltage from '~/icons/store/batteryVoltage.svg';
import Cables from '~/icons/store/cables.svg';
import CableType from '~/icons/store/cableType.svg';
import Capacity from '~/icons/store/capacity.svg';
import CellType from '~/icons/store/cellType.svg';
import Colour from '~/icons/store/colour.svg';
import Container from '~/icons/store/container.svg';
import Containers from '~/icons/store/containers.svg';
import Delivery2 from '~/icons/store/delivery.svg';
import NoResults from '~/icons/store/filter-no-results.svg';
import Filter from '~/icons/store/filter.svg';
import InverterPower from '~/icons/store/inverterPower.svg';
import Inverters from '~/icons/store/inverters.svg';
import InverterType from '~/icons/store/inverterType.svg';
import Insulation from '~/icons/store/insulation.svg';
import Length from '~/icons/store/length.svg';
import MaxDCVoltage from '~/icons/store/maxDCVoltage.svg';
import ModulePower from '~/icons/store/modulePower.svg';
import Modules from '~/icons/store/modules.svg';
import ModuleType from '~/icons/store/moduleType.svg';
import MountingSystems from '~/icons/store/mountingSystems.svg';
import NumberOfPhases from '~/icons/store/numberOfPhases.svg';
import Optimizer from '~/icons/store/optimizer.svg';
import Others from '~/icons/store/others.svg';
import OutputPower from '~/icons/store/outputPower.svg';
import Pallet from '~/icons/store/pallet.svg';
import PanelEfficiency from '~/icons/store/panelEfficiency.svg';
import Search from '~/icons/store/search.svg';
import Storage from '~/icons/store/storage.svg';
import Wallboxes from '~/icons/store/wallboxes.svg';
import Warranty from '~/icons/store/warranty.svg';
import SupportContact from '~/icons/supportContact.svg';
import DotPointTarget from '~/icons/dot-point-target.svg';
import ThreeDotsHorizontal from '~/icons/three-dots-horizontal.svg';
import ThreeDotsVertical from '~/icons/three-dots-vertical.svg';
import Timer from '~/icons/timer.svg';
import CustomerSupport from '~/icons/track-and-trace/customer-support.svg';
import LocationOffice from '~/icons/track-and-trace/location-office.svg';
import Phone from '~/icons/track-and-trace/phone.svg';
import ChevronRight from '~/icons/track-and-trace/progress-bar/chevron-right.svg';
import Delivered from '~/icons/track-and-trace/progress-bar/delivered.svg';
import InManufacturing from '~/icons/track-and-trace/progress-bar/in-manufacturing.svg';
import TransferCart from '~/icons/track-and-trace/progress-bar/transfer-cart.svg';
import Truck from '~/icons/track-and-trace/progress-bar/truck.svg';
import TravelMapLocationPin from '~/icons/travel-map-location-pin.svg';
import Upload from '~/icons/upload.svg';
import Wallet from '~/icons/wallet.svg';
import WhatsApp from '~/icons/whats-app.svg';
import Tracking from '~/icons/tracking.svg';
import CalendarSchedule from '~/icons/calendar-schedule.svg';
import CalendarTime from '~/icons/calendar-time.svg';
import CalendarWeekAvailable from '~/icons/calendar-week-available.svg';
import CalendarWeekNotAvailable from '~/icons/calendar-week-not-available.svg';
import Warehouse from '~/icons/warehouse.svg';
import MinusCircleNotAllowed from '~/icons/minus-circle-not-allowed.svg';
import Refresh from '~/icons/refresh.svg';
import BasketCart from '~/icons/basket-cart.svg';
import Trash from '~/icons/trash.svg';
import BillingStriked from '~/icons/billing-striked.svg';
import CartBNPL from '~/icons/cart-bnpl.svg';
import CartSuccess from '~/icons/cart-success.svg';
import ProductOutOfStock from '~/icons/product-out-of-stock.svg';
import QuestionMarkCircle from '~/icons/question-mark-circle.svg';
import Message from '~/icons/message.svg';
import FinancingFee from '~/icons/financing-fee.svg';
import UploadDocuments from '~/icons/upload-documents.svg';
import Order from '~/icons/order.svg';
import Summary from '~/icons/summary.svg';
import RadioButtonChecked from '~/icons/radio-button-checked.svg';
import RadioButtonUnchecked from '~/icons/radio-button-unchecked.svg';
import PackageOpen from '~/icons/package-open.svg';
import AmountWrong from '~/icons/amount-wrong.svg';
import Hamburger from '~/icons/hamburger.svg';
import LinkedIn from '~/icons/linkedin.svg';

// External imports
import { Suspense } from 'react';
import { twMerge } from 'tailwind-merge';
import { ColorModeEnum } from '~/utils/generalUtils';
import { colors } from '~/utils/tailwindUtils';
import Flex from '../customComponents/flex/Flex';

interface IconType {
  [key: string]: React.SVGProps<SVGSVGElement>;
}

/**
 * IconName enum to define all the icons used in the application
 */
export enum IconName {
  Add = 'add',
  Alert = 'alert',
  AndercoreA = 'andercore-a',
  AndercoreLogoBig = 'andercore-logo-big',
  AndercoreLogoSmall = 'andercore-logo-small',
  ArrowLeft = 'arrow-left',
  ArrowRight = 'arrow-right',
  Archived = 'archived',
  Billing = 'billing',
  BillingStriked = 'billing-striked',
  BusinessHandshake = 'business-handshake',
  HandPointingRight = 'hand-pointing-right',
  Cancel = 'cancel',
  CancelCircle = 'cancel-circle',
  CartBNPL = 'cart-bnpl',
  CartSuccess = 'cart-success',
  CategoryInverter = 'category-inverter',
  ChatBubble = 'chat-bubble',
  CheckCircle = 'check-circle',
  SuccessfulChecked = 'successful-checked',
  ChatQuestionMark = 'chat-question-mark',
  Check = 'check',
  CheckboxUnchecked = 'checkbox-unchecked',
  CheckboxChecked = 'checkbox-checked',
  ChevronDown = 'chevron-down',
  ChevronUp = 'chevron-up',
  ClaimBilling = 'claimBilling',
  Calendar = 'calendar',
  Calculator = 'calculator',
  CalendarWeek = 'calendarWeek',
  CalendarSchedule = 'calendarSchedule',
  CalendarWeekAvailable = 'calendarWeekAvailable',
  CalendarWeekNotAvailable = 'calendarWeekNotAvailable',
  CalendarTime = 'calendarTime',
  ClaimDelivery = 'claimDelivery',
  ClaimManagement = 'claimManagement',
  Copy = 'copy',
  Dispute = 'dispute',
  Documents = 'documents',
  Dimensions = 'dimensions',
  DisabledTag = 'disabledTag',
  Flag = 'flag',
  LastUpdated = 'lastUpdated',
  InfoCircle = 'info-circle',
  MessageRead = 'messageRead',
  NoComments = 'noComments',
  Comment = 'comment',
  Pieces = 'pieces',
  BillingInformation = 'billingInformation',
  LateDelivery = 'lateDelivery',
  MaterialDefect = 'materialDefect',
  OtherReason = 'otherReason',
  PackagingDamage = 'packagingDamage',
  PaidAlready = 'paidAlready',
  PaymentAmount = 'paymentAmount',
  Performance = 'performance',
  ProductQuantity = 'productQuantity',
  ProductionDate = 'productionDate',
  SerialNumber = 'serialNumber',
  ReasonSoftware = 'reasonSoftware',
  WrongProducts = 'wrongProducts',
  Pallets = 'pallets',
  Resolved = 'resolved',
  Clock = 'clock',
  CoffeeMug = 'coffeeMug',
  Coins = 'coins',
  CoreLogo = 'coreLogo',
  Collapse = 'collapse',
  DE = 'DE',
  EN = 'EN',
  ES = 'ES',
  FR = 'FR',
  IT = 'IT',
  BE = 'BE',
  NL = 'NL',
  PT = 'PT',
  AT = 'AT',
  PL = 'PL',
  CH = 'CH',
  CZ = 'CZ',
  DeliveryTruck = 'deliveryTruck',
  DeliveryInProgress = 'deliveryInProgress',
  DeliveryCompleted = 'deliveryCompleted',
  DeliveryCancelled = 'deliveryCancelled',
  OnHoldOrPause = 'onHoldOrPause',
  Delivery = 'delivery',
  Discount = 'discount',
  Document = 'document',
  Download = 'download',
  Pencil = 'pencil',
  EmptyBilling = 'emptyBilling',
  NoClaims = 'noClaims',
  EmptyNotFound = 'emptyNotFound',
  EmptyOrders = 'emptyOrders',
  EmptyQuotes = 'emptyQuotes',
  IllustrativeSearch = 'illustrativeSearch',
  LinkedIn = 'linkedin',
  Envelope = 'envelope',
  Expand = 'expand',
  EyeClosed = 'eyeClosed',
  EyeOpen = 'eyeOpen',
  FileAttachement = 'fileAttachement',
  HomeBig = 'homeBig',
  Home = 'home',
  InvoiceDue = 'invoiceDue',
  Loader = 'loader',
  Location = 'location',
  Logout = 'logout',
  Mail = 'mail',
  Minus = 'minus',
  MinusCircleNotAllowed = 'minusCircleNotAllowed',
  OfficeBuilding = 'officeBuilding',
  Order = 'order',
  Orders = 'orders',
  OrderPlaced = 'orderPlaced',
  OrderConfirmed = 'orderConfirmed',
  OrderCompleted = 'orderCompleted',
  OrderCancelled = 'orderCancelled',
  Percent = 'percent',
  Printer = 'printer',
  Profile = 'profile',
  Quotes = 'quotes',
  Settings = 'settings',
  Shop = 'shop',
  Smartphone = 'smartphone',
  AcPowerRange = 'acPowerRange',
  Batteries = 'batteries',
  BatteryVoltage = 'batteryVoltage',
  Cables = 'cables',
  CableType = 'cableType',
  Capacity = 'capacity',
  CellType = 'cellType',
  Colour = 'colour',
  Container = 'container',
  Containers = 'containers',
  Delivery2 = 'delivery2',
  NoResults = 'noResults',
  Filter = 'filter',
  InverterPower = 'inverterPower',
  Inverters = 'inverters',
  InverterType = 'inverterType',
  Insulation = 'insulation',
  Length = 'length',
  MaxDCVoltage = 'maxDCVoltage',
  ModulePower = 'modulePower',
  Modules = 'modules',
  MountingSystems = 'mountingSystems',
  ModuleType = 'moduleType',
  NumberOfPhases = 'numberOfPhases',
  Optimizer = 'optimizer',
  Others = 'others',
  OutputPower = 'outputPower',
  Pallet = 'pallet',
  PanelEfficiency = 'panelEfficiency',
  ProductOutOfStock = 'productOutOfStock',
  Search = 'search',
  Storage = 'storage',
  Wallboxes = 'wallboxes',
  Warranty = 'warranty',
  SupportContact = 'supportContact',
  Timer = 'timer',
  Tracking = 'tracking',
  CustomerSupport = 'customerSupport',
  LocationOffice = 'locationOffice',
  Phone = 'phone',
  ChevronLeft = 'chevronLeft',
  ChevronRight = 'chevronRight',
  Delivered = 'delivered',
  InManufacturing = 'inManufacturing',
  TransferCart = 'transferCart',
  Truck = 'truck',
  ShippingBox = 'shippingBox',
  TravelMapLocationPin = 'travelMapLocationPin',
  Upload = 'upload',
  Wallet = 'wallet',
  WhatsApp = 'whatsApp',
  QuoteNew = 'QuoteNew',
  PadLock = 'padLock',
  ClipboardCheck = 'clipboardCheck',
  DeliveryScheduled = 'DeliveryScheduled',
  EmptyList = 'EmptyList',
  DotPointTarget = 'dotPointTarget',
  ThreeDotsHorizontal = 'ThreeDotsHorizontal',
  ThreeDotsVertical = 'ThreeDotsVertical',
  Hourglass = 'hourglass',
  Offers = 'offers',
  OfferOpen = 'offerOpen',
  OfferRejected = 'offerRejected',
  PackageDelivered = 'packageDelivered',
  PackageCancelled = 'packageCancelled',
  FallbackImage = 'fallbackImage',
  ContactDetails = 'ContactDetails',
  Bell = 'Bell',
  BillingAddress = 'BillingAddress',
  DeliveryContact = 'DeliveryContact',
  CompanyBuilding = 'CompanyBuilding',
  Lock = 'Lock',
  Cookies = 'Cookies',
  CookiesPreferences = 'CookiesPreferences',
  CheckboxUnChecked = 'CheckboxUnChecked',
  DocumentLines = 'DocumentLines',
  DesktopWithPerson = 'DesktopWithPerson',
  Preferences = 'Preferences',
  AlertTriangle = 'AlertTriangle',
  Warehouse = 'Warehouse',
  Refresh = 'Refresh',
  BasketCart = 'BasketCart',
  Trash = 'Trash',
  QuestionMarkCircle = 'QuestionMarkCircle',
  Message = 'Message',
  FinancingFee = 'FinancingFee',
  UploadDocuments = 'UploadDocuments',
  Summary = 'Summary',
  RadioButtonChecked = 'RadioButtonChecked',
  RadioButtonUnchecked = 'RadioButtonUnchecked',
  PackageOpen = 'PackageOpen',
  AmountWrong = 'AmountWrong',
  Hamburger = 'Hamburger',
}

const iconType: IconType = {
  [IconName.Add]: Add,
  [IconName.Alert]: Alert,
  [IconName.AndercoreA]: AndercoreA,
  [IconName.AndercoreLogoBig]: AndercoreLogoBig,
  [IconName.AndercoreLogoSmall]: AndercoreLogoSmall,
  [IconName.ArrowLeft]: ArrowLeft,
  [IconName.ArrowRight]: ArrowRight,
  [IconName.Archived]: Archived,
  [IconName.Billing]: Billing,
  [IconName.BillingStriked]: BillingStriked,
  [IconName.BusinessHandshake]: BusinessHandshake,
  [IconName.HandPointingRight]: HandPointingRight,
  [IconName.Cancel]: Cancel,
  [IconName.CancelCircle]: CancelCircle,
  [IconName.CartBNPL]: CartBNPL,
  [IconName.CartSuccess]: CartSuccess,
  [IconName.CategoryInverter]: CategoryInverter,
  [IconName.ChatBubble]: ChatBubble,
  [IconName.ChatQuestionMark]: ChatQuestionMark,
  [IconName.CheckCircle]: CheckCircle,
  [IconName.SuccessfulChecked]: SuccessfulChecked,
  [IconName.Check]: Check,
  [IconName.CheckboxUnchecked]: CheckboxUnchecked,
  [IconName.CheckboxChecked]: CheckboxChecked,
  [IconName.ChevronDown]: ChevronDown,
  [IconName.ChevronUp]: ChevronUp,
  [IconName.ClaimBilling]: ClaimBilling,
  [IconName.Calendar]: Calendar,
  [IconName.Calculator]: Calculator,
  [IconName.CalendarWeek]: CalendarWeek,
  [IconName.CalendarWeekAvailable]: CalendarWeekAvailable,
  [IconName.CalendarWeekNotAvailable]: CalendarWeekNotAvailable,
  [IconName.CalendarSchedule]: CalendarSchedule,
  [IconName.CalendarTime]: CalendarTime,
  [IconName.ClaimDelivery]: ClaimDelivery,
  [IconName.ClaimManagement]: ClaimManagement,
  [IconName.Copy]: Copy,
  [IconName.Dispute]: DisputeBubble,
  [IconName.Documents]: Documents,
  [IconName.Dimensions]: Dimensions,
  [IconName.DisabledTag]: DisabledTag,
  [IconName.Flag]: Flag,
  [IconName.LastUpdated]: LastUpdated,
  [IconName.MessageRead]: MessageRead,
  [IconName.NoComments]: NoComments,
  [IconName.Comment]: Comment,
  [IconName.Pieces]: Pieces,
  [IconName.InfoCircle]: InfoCircle,
  [IconName.BillingInformation]: BillingInformation,
  [IconName.LateDelivery]: LateDelivery,
  [IconName.MaterialDefect]: MaterialDefect,
  [IconName.OtherReason]: OtherReason,
  [IconName.PackagingDamage]: PackagingDamage,
  [IconName.PaidAlready]: PaidAlready,
  [IconName.PaymentAmount]: PaymentAmount,
  [IconName.Performance]: Performance,
  [IconName.ProductQuantity]: ProductQuantity,
  [IconName.ProductionDate]: ProductionDate,
  [IconName.ProductOutOfStock]: ProductOutOfStock,
  [IconName.SerialNumber]: SerialNumber,
  [IconName.ReasonSoftware]: ReasonSoftware,
  [IconName.WrongProducts]: WrongProducts,
  [IconName.Pallets]: Pallets,
  [IconName.Resolved]: Resolved,
  [IconName.Clock]: Clock,
  [IconName.CoffeeMug]: CoffeeMug,
  [IconName.Coins]: Coins,
  [IconName.CoreLogo]: CoreLogo,
  [IconName.Collapse]: Collapse,
  [IconName.DE]: DE,
  [IconName.EN]: EN,
  [IconName.ES]: ES,
  [IconName.FR]: FR,
  [IconName.IT]: IT,
  [IconName.BE]: BE,
  [IconName.NL]: NL,
  [IconName.PT]: PT,
  [IconName.AT]: AT,
  [IconName.PL]: PL,
  [IconName.CH]: CH,
  [IconName.CZ]: CZ,
  [IconName.DeliveryTruck]: DeliveryTruck,
  [IconName.DeliveryInProgress]: DeliveryInProgress,
  [IconName.DeliveryCompleted]: DeliveryCompleted,
  [IconName.DeliveryCancelled]: DeliveryCancelled,
  [IconName.OnHoldOrPause]: OnHoldOrPause,
  [IconName.Delivery]: Delivery,
  [IconName.Discount]: Discount,
  [IconName.Document]: Document,
  [IconName.Download]: Download,
  [IconName.Pencil]: Pencil,
  [IconName.EmptyBilling]: EmptyBilling,
  [IconName.NoClaims]: NoClaims,
  [IconName.EmptyNotFound]: EmptyNotFound,
  [IconName.EmptyOrders]: EmptyOrders,
  [IconName.EmptyQuotes]: EmptyQuotes,
  [IconName.IllustrativeSearch]: IllustrativeSearch,
  [IconName.LinkedIn]: LinkedIn,
  [IconName.Envelope]: Envelope,
  [IconName.Expand]: Expand,
  [IconName.EyeClosed]: EyeClosed,
  [IconName.EyeOpen]: EyeOpen,
  [IconName.FileAttachement]: FileAttachement,
  [IconName.HomeBig]: HomeBig,
  [IconName.Home]: Home,
  [IconName.InvoiceDue]: InvoiceDue,
  [IconName.Loader]: Loader,
  [IconName.Location]: Location,
  [IconName.Logout]: Logout,
  [IconName.Mail]: Mail,
  [IconName.Minus]: Minus,
  [IconName.MinusCircleNotAllowed]: MinusCircleNotAllowed,
  [IconName.OfficeBuilding]: OfficeBuilding,
  [IconName.Order]: Order,
  [IconName.Orders]: Orders,
  [IconName.OrderPlaced]: OrderPlaced,
  [IconName.OrderConfirmed]: OrderConfirmed,
  [IconName.OrderCompleted]: OrderCompleted,
  [IconName.OrderCancelled]: OrderCancelled,
  [IconName.Percent]: Percent,
  [IconName.Printer]: Printer,
  [IconName.Profile]: Profile,
  [IconName.Quotes]: Quotes,
  [IconName.Settings]: Settings,
  [IconName.Shop]: Shop,
  [IconName.Smartphone]: Smartphone,
  [IconName.AcPowerRange]: AcPowerRange,
  [IconName.Batteries]: Batteries,
  [IconName.BatteryVoltage]: BatteryVoltage,
  [IconName.Cables]: Cables,
  [IconName.CableType]: CableType,
  [IconName.Capacity]: Capacity,
  [IconName.CellType]: CellType,
  [IconName.Colour]: Colour,
  [IconName.Container]: Container,
  [IconName.Containers]: Containers,
  [IconName.Delivery2]: Delivery2,
  [IconName.NoResults]: NoResults,
  [IconName.Filter]: Filter,
  [IconName.InverterPower]: InverterPower,
  [IconName.Inverters]: Inverters,
  [IconName.InverterType]: InverterType,
  [IconName.Insulation]: Insulation,
  [IconName.Length]: Length,
  [IconName.MaxDCVoltage]: MaxDCVoltage,
  [IconName.ModulePower]: ModulePower,
  [IconName.Modules]: Modules,
  [IconName.MountingSystems]: MountingSystems,
  [IconName.ModuleType]: ModuleType,
  [IconName.NumberOfPhases]: NumberOfPhases,
  [IconName.Optimizer]: Optimizer,
  [IconName.Others]: Others,
  [IconName.OutputPower]: OutputPower,
  [IconName.Pallet]: Pallet,
  [IconName.PanelEfficiency]: PanelEfficiency,
  [IconName.Search]: Search,
  [IconName.Storage]: Storage,
  [IconName.Wallboxes]: Wallboxes,
  [IconName.Warranty]: Warranty,
  [IconName.SupportContact]: SupportContact,
  [IconName.Timer]: Timer,
  [IconName.Tracking]: Tracking,
  [IconName.CustomerSupport]: CustomerSupport,
  [IconName.LocationOffice]: LocationOffice,
  [IconName.Phone]: Phone,
  [IconName.ChevronLeft]: ChevronLeft,
  [IconName.ChevronRight]: ChevronRight,
  [IconName.Delivered]: Delivered,
  [IconName.InManufacturing]: InManufacturing,
  [IconName.TransferCart]: TransferCart,
  [IconName.Truck]: Truck,
  [IconName.ShippingBox]: ShippingBox,
  [IconName.TravelMapLocationPin]: TravelMapLocationPin,
  [IconName.Upload]: Upload,
  [IconName.Wallet]: Wallet,
  [IconName.WhatsApp]: WhatsApp,
  [IconName.QuoteNew]: QuoteNew,
  [IconName.Bell]: Bell,
  [IconName.PadLock]: PadLock,
  [IconName.ClipboardCheck]: ClipboardCheck,
  [IconName.DeliveryScheduled]: DeliveryScheduled,
  [IconName.EmptyList]: EmptyList,
  [IconName.DotPointTarget]: DotPointTarget,
  [IconName.ThreeDotsHorizontal]: ThreeDotsHorizontal,
  [IconName.ThreeDotsVertical]: ThreeDotsVertical,
  [IconName.Hourglass]: HourGlass,
  [IconName.Offers]: Offers,
  [IconName.OfferOpen]: OfferOpen,
  [IconName.OfferRejected]: OfferRejected,
  [IconName.PackageDelivered]: PackageDelivered,
  [IconName.PackageCancelled]: PackageCancelled,
  [IconName.FallbackImage]: FallbackImage,
  [IconName.ContactDetails]: ContactDetails,
  [IconName.BillingAddress]: BillingAddress,
  [IconName.DeliveryContact]: DeliveryContact,
  [IconName.CompanyBuilding]: CompanyBuilding,
  [IconName.Lock]: Lock,
  [IconName.Cookies]: Cookies,
  [IconName.CookiesPreferences]: CookiesPreferences,
  [IconName.CheckboxUnChecked]: CheckboxUnChecked,
  [IconName.DocumentLines]: DocumentLines,
  [IconName.DesktopWithPerson]: DesktopWithPerson,
  [IconName.Preferences]: Preferences,
  [IconName.AlertTriangle]: AlertTriangle,
  [IconName.Warehouse]: Warehouse, // Delivered, Delivery
  [IconName.Refresh]: Refresh,
  [IconName.BasketCart]: BasketCart,
  [IconName.Trash]: Trash,
  [IconName.QuestionMarkCircle]: QuestionMarkCircle,
  [IconName.Message]: Message,
  [IconName.FinancingFee]: FinancingFee,
  [IconName.UploadDocuments]: UploadDocuments,
  [IconName.Summary]: Summary,
  [IconName.RadioButtonChecked]: RadioButtonChecked,
  [IconName.RadioButtonUnchecked]: RadioButtonUnchecked,
  [IconName.PackageOpen]: PackageOpen,
  [IconName.AmountWrong]: AmountWrong,
  [IconName.Hamburger]: Hamburger,
};

export interface IconProps extends React.HTMLAttributes<HTMLDivElement> {
  name: string;
  size?: number;
  width?: number;
  height?: number;
  hovered?: boolean;
  color?: string;
  colorMode?: 'fill' | 'stroke';
  customStrokeWidth?: number;
  style?: React.CSSProperties;
}

/**
 * Icon component to render SVG icons
 * - name: Ex: IconName.Home
 * - size: 24 default
 * - width: default undefined so size will be added to width, if defined it will override size
 * - height: default undefined so size will be added to height, if defined it will override size
 * - hovered: boolean to change color on hover
 * - color: default #3B3F44
 * - colorMode: 'fill' | 'stroke' default 'stroke'
 * - customStrokeWidth: number to override default stroke width of 1
 * - className: string to add custom classes to Flex component surrounding the icon
 * - ...restProps: any other props to be passed to the Flex component
 */
export const Icon = ({
  name,
  size = 24,
  width,
  height,
  style,
  hovered,
  color = colors.primary,
  colorMode = ColorModeEnum.Stroke,
  customStrokeWidth,
  className,
  ...restProps
}: IconProps) => {
  let Icon = (iconType[name] || Home) as React.FC<React.SVGProps<SVGSVGElement>>;

  const strokeWidth = colorMode === ColorModeEnum.Stroke ? 1 : 0;
  const fill = colorMode === ColorModeEnum.Fill ? color : 'none';

  return (
    <Flex className={twMerge('justify-center items-center', className)} {...restProps}>
      <Suspense fallback={<></>}>
        <Icon
          data-testid="icon"
          stroke={hovered ? colors.red[600] : color}
          height={height ?? size}
          width={width ?? size}
          strokeWidth={customStrokeWidth || strokeWidth}
          fill={fill}
          {...(style && { style })}
        />
      </Suspense>
    </Flex>
  );
};
